import axios from "axios";
import { BACKEND } from "../variables";
const GET_STATISTICS_URL = BACKEND + "/statistics";
const GET_REPORTS_URL = BACKEND + "/reports";
const GET_REPORT_REVENUE_PDF_URL = BACKEND + "/reports/revenue-pdf";
const GET_REPORT_EXPENSE_PDF_URL = BACKEND + "/reports/expense-pdf";
const GET_REPORT_TAX_PDF_URL = BACKEND + "/reports/tax-pdf";
const GET_REPORT_SUBSCRIPTIONS_PDF_URL = BACKEND + "/reports/subscriptions-pdf";
const GET_REPORT_AREA_PDF_URL = BACKEND + "/reports/area-pdf";
const GET_REPORT_FINANCIAL_PDF_URL = BACKEND + "/reports/financial-pdf";
const GET_REPORT_TABLE_PDF_URL = BACKEND + "/reports/table-pdf";

const site = {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ["GET_STATISTICS"]: (state, payload) => {
      return axios({
        url: GET_STATISTICS_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: `${payload.token}`,
        },
      });
    },
    ["GET_REPORTS"]: (state, payload) => {
      return axios({
        url: GET_REPORTS_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: `${payload.token}`,
        },
      });
    },
    /** Generic table PDF: renders the rows the screen is showing (see utils/tablePdf.js). */
    ["GET_REPORT_TABLE_PDF"]: (state, payload) => {
      return axios({
        url: GET_REPORT_TABLE_PDF_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: `${payload.token}`,
        },
        responseType: "blob",
      });
    },
    ["GET_REPORT_REVENUE_PDF"]: (state, payload) => {
      return axios({
        url: GET_REPORT_REVENUE_PDF_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: `${payload.token}`,
        },
        responseType: "blob",
      });
    },
    ["GET_REPORT_EXPENSE_PDF"]: (state, payload) => {
      return axios({
        url: GET_REPORT_EXPENSE_PDF_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: `${payload.token}`,
        },
        responseType: "blob",
      });
    },
    ["GET_REPORT_TAX_PDF"]: (state, payload) => {
      return axios({
        url: GET_REPORT_TAX_PDF_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: `${payload.token}`,
        },
        responseType: "blob",
      });
    },
    ["GET_REPORT_SUBSCRIPTIONS_PDF"]: (state, payload) => {
      return axios({
        url: GET_REPORT_SUBSCRIPTIONS_PDF_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: `${payload.token}`,
        },
        responseType: "blob",
      });
    },
    ["GET_REPORT_AREA_PDF"]: (state, payload) => {
      return axios({
        url: GET_REPORT_AREA_PDF_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: `${payload.token}`,
        },
        responseType: "blob",
      });
    },
    ["GET_REPORT_FINANCIAL_PDF"]: (state, payload) => {
      return axios({
        url: GET_REPORT_FINANCIAL_PDF_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: `${payload.token}`,
        },
        responseType: "blob",
      });
    },
  },
  modules: {},
};
export default site;
